import {MDTState, State} from '..';

export const complete = (state: MDTState, getters: unknown, rootState: State): boolean => {
  return (state.answers.id !== undefined && state.answers.id !== null) ||
      (rootState.package.policies?.toolsAndEquipment?.toolsAndEquipment?.id !== undefined && rootState.package.policies?.toolsAndEquipment.toolsAndEquipment.id !== null);
};

export const extraQuestionsComplete = (state: MDTState): boolean => {
  return (
    state.answers.scaffoldingValue !== undefined &&
    state.answers.scaffoldingValue !== null
  );
};
